import React, { useState, useEffect } from 'react';
import CookieConsent, { Cookies, resetCookieConsentValue } from 'react-cookie-consent';
import { BiCookie } from 'react-icons/bi';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

//test
var CookieBanner = function CookieBanner(_ref) {
  var url = _ref.url,
    disableUrl = _ref.disableUrl;
  var _useState = useState(false),
    showReset = _useState[0],
    setShowReset = _useState[1];
  var newUrl = url || "/policies/privacy-policy";
  useEffect(function () {
    if (Cookies.get("CookieConsent") === "true" || Cookies.get("CookieConsent") === "false") {
      setShowReset(true);
    }
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("style", null, "\n\n\n.policy-link {\n  color: white !important;\n}\n.policy-link:hover {\n  color: #6b6b6b !important; ;\n}\n\n.decline-button-style{ width: 100%; max-width:100% !important;}\n\n.accept-button-style{width: 100%; max-width:100% !important;}\n.CookieConsent{display: block !important;  overflow: hidden !important; padding-right: 30px !important;}\n\n@media (min-width: 768px) {.decline-button-style {\n        width: auto;\n    }\n.CookieConsent{display: flex !important; padding-right: 0px !important;}\n    .accept-button-style {\n        width: auto;\n    }}\n}"), showReset && React.createElement(React.Fragment, null, React.createElement("div", {
    id: "app-title",
    onClick: function onClick() {
      setShowReset(false);
      resetCookieConsentValue();
      window.location.reload();
    },
    style: {
      zIndex: 999999,
      left: '1rem',
      bottom: '1rem',
      width: '50px',
      height: '50px',
      cursor: 'pointer',
      color: 'white',
      borderRadius: "100%",
      background: "black"
    },
    className: "position-fixed   d-flex align-items-center justify-content-center "
  }, React.createElement(BiCookie, {
    style: {
      fontSize: "1.5rem"
    }
  })), React.createElement(Tooltip, {
    opacity: 1,
    style: {
      background: "black",
      zIndex: 999999
    },
    anchorSelect: "#app-title",
    place: "top",
    content: "Manage cookies"
  })), !showReset && React.createElement("div", {
    className: "d-none d-md-block"
  }, React.createElement(CookieConsent, {
    buttonClasses: "accept-button-style",
    declineButtonClasses: "decline-button-style",
    enableDeclineButton: true,
    declineButtonText: "Decline",
    location: "bottom",
    buttonText: React.createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, " ", React.createElement(BiCookie, {
      style: {
        fontSize: "1rem"
      }
    }), " Accept"),
    onAccept: function onAccept() {
      window.location.reload();
    },
    onDecline: function onDecline() {
      setShowReset(true);
    },
    style: {
      background: 'black'
    },
    declineButtonStyle: {
      backgroundColor: 'black'
    },
    buttonStyle: {
      color: 'black',
      fontSize: '1rem',
      backgroundColor: 'white',
      paddingLeft: "2.5rem",
      paddingRight: "2.5rem",
      paddingTop: "0.6rem",
      paddingBottom: "0.6rem"
    },
    expires: 365
  }, disableUrl !== true && React.createElement("div", null, "This website stores data such as cookies to enable site functionality including analytics and personalisation. Click", " ", React.createElement("a", {
    href: newUrl,
    target: "_blank",
    rel: "noreferrer",
    className: 'policy-link'
  }, "here"), " ", "for policy."), disableUrl === true && React.createElement("div", null, "This website stores data such as cookies to enable site functionality including analytics and personalisation."))), !showReset && React.createElement("div", {
    className: "d-md-none"
  }, React.createElement(CookieConsent, {
    flipButtons: true,
    buttonClasses: "accept-button-style",
    declineButtonClasses: "decline-button-style",
    enableDeclineButton: true,
    declineButtonText: React.createElement("span", null, " ", React.createElement(BiCookie, {
      style: {
        fontSize: "1rem",
        color: "black"
      }
    }), " Decline"),
    location: "bottom",
    buttonText: React.createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, " ", React.createElement(BiCookie, {
      style: {
        fontSize: "1rem"
      }
    }), " Accept"),
    onAccept: function onAccept() {
      window.location.reload();
    },
    onDecline: function onDecline() {
      setShowReset(true);
    },
    style: {
      background: 'black'
    },
    declineButtonStyle: {
      backgroundColor: 'black',
      marginRight: "30px"
    },
    buttonStyle: {
      color: 'black',
      fontSize: '1rem',
      marginRight: "30px",
      backgroundColor: 'white',
      paddingTop: "0.6rem",
      paddingBottom: "0.6rem"
    },
    expires: 365
  }, disableUrl !== true && React.createElement("div", null, "This website stores data such as cookies to enable site functionality including analytics and personalisation. Click", " ", React.createElement("a", {
    href: newUrl,
    target: "_blank",
    rel: "noreferrer",
    className: 'policy-link'
  }, "here"), " ", "for policy."), disableUrl === true && React.createElement("div", null, "This website stores data such as cookies to enable site functionality including analytics and personalisation."))));
};

export { CookieBanner };
//# sourceMappingURL=rjm-cookie-banner.esm.js.map
